import { api } from './api';

export interface DbQueryRequest {
  model: string;
  action: 'findMany' | 'create' | 'update' | 'delete' | 'findUnique';
  args?: Record<string, unknown>;
}

export interface DbQueryResponse<T = unknown> {
  success: boolean;
  data: T;
  total?: number;
  error?: string;
}

export interface DbModelField {
  name: string;
  kind: 'scalar' | 'object' | 'enum';
  type: string;
  isArray: boolean;
  isPrimary: boolean;
  isRequired?: boolean;
  isId?: boolean;
}

export interface DbModelDefinition {
  name: string;
  fields: DbModelField[];
  dbName: string | null;
}

export interface DbModelsResponse {
  success: boolean;
  models: DbModelDefinition[];
  enums: Record<string, string[]>;
  error?: string;
}

export const dbManagerService = {
  async executeQuery<T>(data: DbQueryRequest): Promise<DbQueryResponse<T>> {
    return api.post<DbQueryResponse<T>>('/db-manager/query', data);
  },

  async listarModelos(): Promise<DbModelsResponse> {
    return api.get<DbModelsResponse>('/db-manager/models');
  },
};
